import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { IconComponent } from '@fnccr-actee/design-system';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { OnboardingController } from '../../onboarding.controller';
import { OnboardingInfoCardComponent } from '../../ui/onboarding-info-card/onboarding-info-card.component';

@Component({
  selector: 'app-onboarding-step-one',
  imports: [OnboardingInfoCardComponent, IconComponent, NgOptimizedImage, TranslatePipe],
  templateUrl: './onboarding-step-one.component.html',
  styleUrl: '../step.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingStepOneComponent {
  private readonly _controller = inject(OnboardingController);
  private readonly _translate = inject(TranslateService);

  readonly firstName = this._controller.firstName;
  readonly communityName = this._controller.communityName;

  readonly welcomeMessage = computed(() =>
    this.firstName()
      ? this._translate.instant('onboarding.stepOne.welcomeWithName', { name: this.firstName() })
      : this._translate.instant('onboarding.stepOne.welcome'),
  );
}
